import _ from "lodash";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { ROLE_VISITOR } from "Constants/stringConstants";
import { getUserArchivalStatus } from "modules/CommonSelectors";

export const getOptionItemDetails = ({
  item,
  approvedExternalCollaborators,
}) => {
  const {
    curriculumPrograms,
    id,
    profileImage,
    email,
    role,
    otherDetails,
    isExternalOldData = false,
    type,
  } = item;

  const isArchived = getUserArchivalStatus(item);

  const { organizationName, phoneNumber } = otherDetails || {};

  const name = getFormattedUserName({
    user: item,
  });

  const itemCurricullamPrograms = _.join(
    _.map(curriculumPrograms, program => program.acronym),
    ", "
  );

  const isExternal = _.isEqual(role, ROLE_VISITOR);
  let isApproved = isExternal ? false : true;

  if (isExternal && approvedExternalCollaborators) {
    isApproved = _.includes(approvedExternalCollaborators, id);
  }

  return {
    name,
    itemCurricullamPrograms,
    id,
    profileImage,
    isArchived,
    isExternal,
    email,
    organizationName,
    phoneNumber,
    isApproved,
    isExternalOldData,
    ...(type === "student"
      ? {
          studentAlertsConfig: {
            studentId: id,
            alertTypes: item?.alertTypes,
          },
        }
      : {}),
  };
};
